import { setGetCampaignByIdAction } from '../action';
import { getCampaignById } from '../api/getCampaignById';

export const setGetCampaignById = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getCampaignById(params);
            dispatch(setGetCampaignByIdAction(data.data))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}